import axios from "axios";

export const API_URL = `${process.env.REACT_APP_API_URL}/merchants`;
export const API_URL_USER = `${process.env.REACT_APP_API_URL}/merchants/users`;

// CREATE =>  POST: add a new product to the server
export function createMerchant(merchant) {
    return axios.post(API_URL, { ...merchant });
}

// READ
export function getAllMerchants() {
    return axios.get(API_URL);
}

export function getPaginatedMerchants(queryParams) {
    return axios.post(`${API_URL}/list`, { ...queryParams });
}

export function getMerchantById(merchantId) {
    return axios.get(`${API_URL}/${merchantId}`);
}

export function createUser(user) {
    return axios.post(`${API_URL_USER}`, { ...user })
}


// // Method from server should return QueryResultsModel(items: any[], totalsCount: number)
// // items => filtered/sorted result
// export function findProducts(queryParams) {
//     return axios.post(`${API_URL}/find`, { queryParams });
// }

// UPDATE => PUT: update the merchant on the server
export function updateMerchant(merchantId, merchant) {
    return axios.put(`${API_URL}/${merchantId}`, { ...merchant });
}


// DELETE => delete the product from the server
export function deleteMerchant(merchantId) {
    return axios.delete(`${API_URL}/${merchantId}`);
}
